const PageHeading = ({ children }) => (
  <h1 className="mt-4 text-[1.3em] md:text-[2.5em] lg:text-[3em] 2xl:text-[4em] font-header text-indigo-900">
    {children}
  </h1>
);

export default PageHeading;
